import {Wallet} from 'lucide-react'
import { lazy, Suspense, useContext } from 'react'
import { WalletReadyContext } from '@/lib/walletContext'

const ConnectWalletButton = lazy(() => import('@/components/ConnectWalletButton'))

type NavbarWalletProps = {
  className?: string
  compact?: boolean
}

function WalletPlaceholder({ className = '', compact = false }: NavbarWalletProps) {
  return (
    <button
      type="button"
      disabled
      aria-label="Connect wallet"
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-lime-400 px-4 py-2 text-sm font-semibold text-black opacity-80 ${className}`}
    >
      <Wallet className="h-4 w-4" aria-hidden="true" />
      {compact ? 'Connect' : 'Connect Wallet'}
    </button>
  )
}

function NavbarWallet({ className = '', compact = false }: NavbarWalletProps) {
  const ready = useContext(WalletReadyContext)

  if (!ready) {
    return <WalletPlaceholder className={className} compact={compact} />
  }

  return (
    <Suspense fallback={<WalletPlaceholder className={className} compact={compact} />}>
      <ConnectWalletButton className={className} compact={compact} />
    </Suspense>
  )
}

export default NavbarWallet
